import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { chatApi } from './chatApi';
import { ChatConversation, ChatMember } from '../types';

const CONV_KEY = ['chat', 'conversations'];

export const useConversations = () =>
  useQuery<ChatConversation[]>(CONV_KEY, chatApi.getConversations, { refetchOnWindowFocus: false, staleTime: 15000 });

export const useConversationMembers = (conversationId?: number) =>
  useQuery<ChatMember[]>(['chat', 'members', conversationId], () => chatApi.getMembers(conversationId as number), {
    enabled: !!conversationId,
    refetchOnWindowFocus: false,
  });

export const useCreateDm = () => {
  const qc = useQueryClient();
  return useMutation((userId: number) => chatApi.createDm(userId), {
    onSuccess: () => qc.invalidateQueries(CONV_KEY),
  });
};

export const useCreateChannel = () => {
  const qc = useQueryClient();
  return useMutation(
    (body: { name: string; description?: string; isPrivate?: boolean; memberIds?: number[] }) => chatApi.createChannel(body),
    { onSuccess: () => qc.invalidateQueries(CONV_KEY) },
  );
};

export const useChatContacts = (params: { page?: number; limit?: number; search?: string }) =>
  useQuery(['chat', 'contacts', params], () => chatApi.getContacts(params), { refetchOnWindowFocus: false, keepPreviousData: true });

export const useChatSearch = (q: string) =>
  useQuery(['chat', 'search', q], () => chatApi.search(q), { enabled: !!q && q.length > 1, refetchOnWindowFocus: false });
